
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.25 13.5A2.252 2.252 0 010 11.25v-9A2.252 2.252 0 012.25 0h18a2.252 2.252 0 012.25 2.25v6a.75.75 0 01-1.5 0v-6a.75.75 0 00-.75-.75h-18a.75.75 0 00-.75.75v9c0 .414.336.75.75.75H9a.75.75 0 010 1.5H2.25z"}}),_c('path',{attrs:{"d":"M17.25 24c-3.722 0-6.75-3.028-6.75-6.75s3.028-6.75 6.75-6.75a.75.75 0 010 1.5C14.355 12 12 14.355 12 17.25s2.355 5.25 5.25 5.25 5.25-2.355 5.25-5.25a.75.75 0 011.5 0A6.758 6.758 0 0117.25 24z"}}),_c('path',{attrs:{"d":"M17.25 19.189c-.4 0-.776-.156-1.059-.438l-1.721-1.72a.743.743 0 01-.22-.53.749.749 0 011.28-.53l1.72 1.719 5.469-5.47a.744.744 0 011.06 0 .752.752 0 010 1.061l-5.47 5.47a1.494 1.494 0 01-1.059.438zM5.25 7.875a1.127 1.127 0 01-.798-1.919 1.127 1.127 0 011.922.794c0 .62-.504 1.125-1.124 1.125zM11.25 7.875a1.127 1.127 0 01-.798-1.919 1.127 1.127 0 011.922.794c0 .62-.504 1.125-1.124 1.125zM17.25 7.875a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25z"}})])
          )
        }
      }
    